'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import KnowledgeBaseLink from '../KnowledgeBaseLink';
import { KBArticles } from 'AdsUI/lib/Constants';
import UIAlert from 'UIComponents/alert/UIAlert';

const TrackingOverrideModal = ({
  name,
  onConfirm,
  onCancel,
  loading,
  error,
  isInstagram = false
}) => /*#__PURE__*/_jsx(UIConfirmModal, {
  message: I18n.text('campaigns.trackingStatus.overrideModal.title'),
  description: /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "campaigns.trackingStatus.overrideModal.body",
      options: {
        name
      }
    }), isInstagram && /*#__PURE__*/_jsx(UIAlert, {
      type: "warning",
      use: "inline",
      className: "m-bottom-2 p-all-4 text-left",
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "campaigns.trackingStatus.overrideModal.instagram.header"
      }),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "campaigns.trackingStatus.overrideModal.instagram.message"
      })
    }), /*#__PURE__*/_jsx(KnowledgeBaseLink, {
      kbArticle: KBArticles.AD_TRACKING,
      context: "override-tracking-modal",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "campaigns.trackingStatus.overrideModal.learnMore"
      })
    })]
  }),
  width: 500,
  ConfirmButton: UILoadingButton,
  confirmButtonProps: {
    loading,
    failed: error,
    use: 'primary'
  },
  onConfirm: onConfirm,
  confirmLabel: I18n.text('campaigns.trackingStatus.overrideModal.ok'),
  rejectLabel: I18n.text('campaigns.trackingStatus.overrideModal.cancel'),
  onReject: onCancel
});

export default TrackingOverrideModal;